module.exports = __webpack_public_path__ + "img/htronic_03A.c29fc50b.png";